import script from "./hotelType.vue?vue&type=script&setup=true&lang=js"
export * from "./hotelType.vue?vue&type=script&setup=true&lang=js"

import "./hotelType.vue?vue&type=style&index=0&id=eff2be82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eff2be82"]])

export default __exports__